var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/timer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.1442 9.14083L7.78753 7H6.20669L3.85003 9.14083C3.19086 9.73583 2.97503 10.6517 3.29586 11.48C3.61669 12.3025 4.39836 12.8333 5.27919 12.8333H8.71503C9.60169 12.8333 10.3775 12.3025 10.6984 11.48C11.0192 10.6517 10.8034 9.73583 10.1442 9.14083ZM8.06169 10.5817H5.93836C5.71669 10.5817 5.54169 10.4008 5.54169 10.185C5.54169 9.96917 5.72253 9.78833 5.93836 9.78833H8.06169C8.28336 9.78833 8.45836 9.96917 8.45836 10.185C8.45836 10.4008 8.27753 10.5817 8.06169 10.5817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.7042 2.52033C10.3834 1.69783 9.60172 1.16699 8.72089 1.16699H5.27922C4.39839 1.16699 3.61672 1.69783 3.29589 2.52033C2.98089 3.34866 3.19672 4.26449 3.85589 4.85949L6.21255 7.00033H7.79339L10.1501 4.85949C10.8034 4.26449 11.0192 3.34866 10.7042 2.52033ZM8.06172 4.21783H5.93839C5.71672 4.21783 5.54172 4.03699 5.54172 3.82116C5.54172 3.60533 5.72255 3.42449 5.93839 3.42449H8.06172C8.28339 3.42449 8.45839 3.60533 8.45839 3.82116C8.45839 4.03699 8.27755 4.21783 8.06172 4.21783Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.34a78d25b52ea0d461b4a9935eda6ae5.svg";
export { ForwardRef as ReactComponent };